import styled from 'styled-components';
import { useIsMsalAuth, useStyledTheme } from '@equifinance/shared';
import { Progress } from '../../../contexts/tasks';
import CircleXMarkIcon from '../../Icons/CircleXMarkIcon';
import CircleCheckIcon from '../../Icons/CircleCheckIcon';

const StatusDefaultLabel = styled.div<{ background?: string, color?: string }>`${({ theme, background, color }) => `
  padding: 3px ${theme.padding[2]};
  background: ${background || theme.colours.primary[10]};
  color: ${color || theme.colours.primary[1]};
  display: flex;
  flex-wrap: wrap;
  border-radius: ${theme.padding[1]};
  font-weight: ${theme.fontWeight.bold};
  width: fit-content;
  line-height: ${theme.padding[4]};
  justify-content: center;
  align-items: center;
  gap: ${theme.padding[1]};
`}`;
export default function TaskStatusLabel({ status }: { status: keyof typeof Progress }) {
  const theme = useStyledTheme();
  const isUnderwriter = useIsMsalAuth();

  switch (status) {
    case 'OutstandingForBroker':
      return (
        <StatusDefaultLabel background={theme.colours.neutral[10]} color={theme.colours.primary[1]}>
          {Progress.OutstandingForBroker}
        </StatusDefaultLabel>
      );
    case 'PendingSubmission':
      return (
        <StatusDefaultLabel background={theme.colours.primary[10]} color={theme.colours.primary[1]}>
          {Progress.PendingSubmission}
        </StatusDefaultLabel>
      );
    case 'SubmittedToLender':
      return (
        <StatusDefaultLabel background={theme.colours.primary[10]} color={theme.colours.primary[1]}>
          {Progress.SubmittedToLender}
        </StatusDefaultLabel>
      );
    case 'MoreInformationRequired':
      return (
        <StatusDefaultLabel background={theme.colours.primary[3]} color={theme.colours.neutral[10]}>
          {Progress.MoreInformationRequired}
        </StatusDefaultLabel>
      );
    case 'Approved':
      return (
        <StatusDefaultLabel background={theme.colours.success[1]} color={theme.colours.neutral[10]}>
          <CircleCheckIcon />
          {Progress.Approved}
        </StatusDefaultLabel>
      );
    case 'ApprovedWithException':
      return (
        <StatusDefaultLabel background={theme.colours.success[1]} color={theme.colours.neutral[10]}>
          <CircleCheckIcon />
          {isUnderwriter ? Progress.ApprovedWithException : Progress.Approved}
        </StatusDefaultLabel>
      );
    case 'Rejected':
      return (
        <StatusDefaultLabel background={theme.colours.danger[1]} color={theme.colours.neutral[10]}>
          <CircleXMarkIcon />
          {Progress.Rejected}
        </StatusDefaultLabel>
      );
    case 'Draft':
      return (
        <StatusDefaultLabel background={theme.colours.primary[7]} color={theme.colours.primary[1]}>
          {Progress.Draft}
        </StatusDefaultLabel>
      );
    default: return <></>;
  }
}
